import "./styles.scss";

import PropTypes from "prop-types";
import React from "react";
import { FaTimes } from "react-icons/fa";

import { IconButton, Alert as MaterialAlert, AlertTitle as MaterialAlertTitle, Slide } from "@mui/material";

const Alert = ({
  title = "",
  message = "",
  type = "success",
  variant = "filled",
  icon = undefined,
  isClosable = true,
  open = false,
  onClose = undefined,
  action = undefined,
}) => {
  let backgroundColor = "#17a17e";
  if (type === "info") {
    backgroundColor = "#3b87ab";
  } else if (type === "warning") {
    backgroundColor = "#ec720a";
  } else if (type === "error") {
    backgroundColor = "#FA2630";
  }

  return (
    <Slide direction="down" in={open}>
      <MaterialAlert
        variant={variant}
        severity={type}
        icon={icon}
        action={
          <>
            {action}
            {isClosable && (
              <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
                <FaTimes fontSize="inherit" />
              </IconButton>
            )}
          </>
        }
        style={{
          position: "fixed",
          top: "1vw",
          left: "1vw",
          right: "1vw",
          width: "98vw",
          zIndex: "10000",
          boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
          minHeight: 60,
          alignItems: "center",
          backgroundColor,
        }}
      >
        <div className="alert-contents-wrapper">
          {title && (
            <MaterialAlertTitle style={{ margin: 0 }}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </MaterialAlertTitle>
          )}
          <span dangerouslySetInnerHTML={{ __html: message || "&nbsp;" }} />
        </div>
      </MaterialAlert>
    </Slide>
  );
};

Alert.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string,
  icon: PropTypes.node,
  isClosable: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  action: PropTypes.node,
};

export default Alert;
